export const downloadBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

// Polski Excel otwiera po dwukliku poprawnie CSV ze średnikiem; domyślnie przecinek jak dotąd
export const downloadCSV = (rows: (string | number | null | undefined)[][], filename: string, separator = ',') => {
  const bom = '﻿';
  const csv = rows
    .map(r => r.map(c => `"${String(c ?? '').replace(/"/g, '""')}"`).join(separator))
    .join('\n');
  downloadBlob(new Blob([bom + csv], { type: 'text/csv;charset=utf-8;' }), filename);
};
